export const PageTitleMixin = {
	created() {
		if (this.pageTitle) {
			document.title = this.pageTitle + ' | ' + document.title;
		}
	},
};
